import { SdfAvatar, SdfCard, SdfCardHeader, SdfMiniCard, SdfShimmer } from '@synerg/react-components';
import React from 'react';

export default function MembersCardShimmer () {

  return (
    <SdfCard style={{ width: "880px", height: "113px" }} spacing={"default"}>
      <div className={"flex flex-row justify-between relative"} style={{bottom: "0.5rem"}}>
        <SdfCardHeader>
          <SdfMiniCard>
            <SdfAvatar size={"lg"} shape={"circle"} slot={"graphic"}/>
            <div slot={"title"} className={"w-72"}>
              <SdfShimmer rows={2}/>
            </div>
          </SdfMiniCard>
        </SdfCardHeader>
        <div className={"flex justify-center items-center relative w-72 "} style={{bottom: "0.5rem", left: "3.0rem"}}>
          <div className={"w-28"}>
            <SdfShimmer rows={2}/>
          </div>
          <div className={"w-4 ml-12"} >
            <SdfShimmer className={"cards-shimmer"} style={{height: "2rem"}} rows={1}/>
          </div>
        </div>
      </div>
    </SdfCard>
  )
}
